import { Row } from '@innovyze/lib-am-common';
import {
	GridRowId,
	GridSortModel,
	GridFilterModel,
	GridPaginationModel,
} from '@innovyze/stylovyze';
import React, { useState } from 'react';
import { useRiskDetailsSelectors } from './useRiskDetailsSelectors';

export function useRiskDetailsStates() {
	const { tablePage, riskDetailsPagination } = useRiskDetailsSelectors();

	const [assetHighlight, setAssetHighlight] = useState<Row[]>([]);
	const [selectionModel, setSelectionModel] = useState<GridRowId[]>([]);
	const initialSortModel: GridSortModel = [
		{
			field: 'CURRENT_RISK',
			sort: 'desc',
		},
	];
	const [sortModel, setSortModel] = useState<GridSortModel>(initialSortModel);
	const initialFilterModel: GridFilterModel = { items: [] };
	const [filterModel, setFilterModel] =
		React.useState<GridFilterModel>(initialFilterModel);
	const [paginationModel, setPaginationModel] =
		React.useState<GridPaginationModel>({
			page: tablePage?.page ? tablePage?.page - 1 : 0,
			pageSize: riskDetailsPagination?.slice ?? 10,
		});

	return {
		assetHighlight,
		setAssetHighlight,
		selectionModel,
		setSelectionModel,
		initialSortModel,
		sortModel,
		setSortModel,
		initialFilterModel,
		filterModel,
		setFilterModel,
		paginationModel,
		setPaginationModel,
	};
}
